import { URL } from 'constants/api.constant'
import ApiService from 'services/ApiService'

export async function apiGetColaboradores(params, token) {
    const queryParams = new URLSearchParams(params).toString()
    if (token) {
        return ApiService.fetchData({
            url: `${URL}/v1/colaboradores-siglo21?${queryParams}`,
            method: 'get',
            headers: {
                Authorization: token
            }
        })

    }
    return ApiService.fetchData({
        url: `${URL}/v1/colaboradores-siglo21?${queryParams}`,
        method: 'get'
    })
}
export async function apiGetColaborador(id) {
    return ApiService.fetchData({
        url: `${URL}/v1/colaboradores-siglo21/${id}`,
        method: 'get'
    })
}

export async function apiUpdateColaborador(id, data) {
    return ApiService.fetchData({
        url: `${URL}/v1/colaboradores-siglo21/${id}`,
        method: 'put',
        data
    })
}

export async function apiDeleteColaborador(id) {
    return ApiService.fetchData({
        url: `${URL}/v1/colaboradores-siglo21/${id}`,
        method: 'delete'
    })
}

export async function apiCreateColaborador(data) {
    return ApiService.fetchData({
        url: `${URL}/v1/colaboradores-siglo21`,
        method: 'post',
        data
    })
}
